import { HTMLList, enumerateElements } from "Shared/ts/utils/html";

/**
 * Iterates through an array of HTML elements and adds an event listener to each element.
 * @param elements HTMLList
 * @param listener (this: Element, ev: Event) => any
 * @param type keyof GlobalEventHandlersEventMap
 */
export const listen = (
    elements: HTMLList,
    listener: (this: Element, ev: Event) => any,
    type?: keyof GlobalEventHandlersEventMap
): void => {
    if (!type) return;

    enumerateElements(elements).forEach((element) => {
        element.addEventListener(type, listener);
    });
};

export const createEvent = <T extends HTMLElement | Window>(
    elem: T,
    eventName: string
): Event => {
    //Needed for IE Support: https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/dispatchEvent#Browser_Compatibility
    //https://stackoverflow.com/a/49071358/79677
    let event;
    if (typeof Event === "function") {
        event = new Event(eventName);
    } else {
        event = document.createEvent("Event");
        event.initEvent(eventName, true, true);
    }
    elem.dispatchEvent(event);

    return event;
};
